import type MoneyExchangerInterface from "@modules/money/MoneyExchanger/MoneyExchangerInterface";
import { MoneyModule } from "@modules/money/MoneyModule";
import { Observable, map, switchMap } from "rxjs";
import { inject, singleton } from "tsyringe";

import { rewardsMoneyExchangerToken } from "../tokens";

@singleton()
class RewardsCurrencyFormatter {
    constructor(
        @inject(rewardsMoneyExchangerToken)
        private readonly rewardsMoneyExchanger: MoneyExchangerInterface,
        private readonly moneyModule: MoneyModule
    ) {}

    private exchange(amount: number): Observable<number> {
        return this.moneyModule.exports.currencyProvider
            .selectCurrency()
            .pipe(
                switchMap((selectedCurrency) =>
                    this.rewardsMoneyExchanger.exchange(
                        amount,
                        selectedCurrency
                    )
                )
            );
    }

    public selectFormattedCurrency(amount: number): Observable<string> {
        return this.exchange(amount).pipe(
            map((amount) =>
                this.moneyModule.exports.moneyFormatter.format(amount)
            )
        );
    }
}

export default RewardsCurrencyFormatter;
